import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { getSubscriptionStatus } from '../../services/stripeService';
import { Lock } from 'lucide-react';

const FeatureGuard = ({ 
  children, 
  featureName = 'this feature',
  showUpgrade = true,
  className = ''
}) => {
  const { user } = useAuth();
  const [hasAccess, setHasAccess] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAccess = async () => {
      if (!user) {
        setHasAccess(false);
        setLoading(false);
        return;
      }

      try {
        const status = await getSubscriptionStatus(user.id);
        const access = status && (
          status.subscription_status === 'active' ||
          (status.subscription_status === 'trial' && !status.isTrialExpired)
        );
        setHasAccess(access);
      } catch (error) {
        console.error('Error checking feature access:', error);
        setHasAccess(false);
      } finally {
        setLoading(false);
      }
    };

    checkAccess();
  }, [user]);

  if (loading) {
    return (
      <div className={`opacity-50 pointer-events-none ${className}`}>
        {children}
      </div>
    );
  }

  if (!hasAccess) {
    return (
      <div className={`relative ${className}`}>
        {/* Blurred content */}
        <div className="filter blur-sm opacity-50 pointer-events-none">
          {children}
        </div>
        
        {/* Overlay */}
        <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-90 rounded-lg">
          <div className="text-center p-4">
            <Lock className="text-sws-purple mx-auto mb-2" size={24} />
            <p className="text-sws-navy font-medium mb-1">
              Upgrade to access {featureName}
            </p>
            {showUpgrade && (
              <button
                onClick={() => window.location.href = '/pricing'}
                className="text-sws-purple hover:text-sws-navy text-sm font-medium"
              >
                View Plans →
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

  return children;
};

export default FeatureGuard;